$(document).ready(function () {
  document.querySelectorAll(".copy").forEach(item => {
    item.addEventListener("click", event => {
      navigator.clipboard.writeText(textToCopy(item));
      updateTooltipWording(item);
    })
  })
})

function textToCopy(item) {
  const textToCopyEl = item.parentNode.querySelector(".text-to-copy");
  const linkToCopyEl = item.parentNode.querySelector(".text-to-copy button");

  if (linkToCopyEl !== null) {
    return linkToCopyEl.dataset["referralLink"];
  } else {
    return textToCopyEl.textContent;
  }
}

function updateTooltipWording(item) {
  const tooltipContainer = item.firstElementChild === null ? item : item.firstElementChild;
  let btnTooltip = bootstrap.Tooltip.getInstance(tooltipContainer);

  if (!btnTooltip) {
    btnTooltip = new bootstrap.Tooltip(tooltipContainer);
  }

  tooltipContainer.setAttribute("data-bs-original-title", getTranslation("copied"));
  btnTooltip.show();
  tooltipContainer.setAttribute("data-bs-original-title", getTranslation("copy"));
}

const translations = {
  en: {
    copied: "Copied to clipboard",
    copy: "Copy"
  },
  fr: {
    copied: "Copié dans le presse-papier",
    copy: "Copier"
  },
  de: {
    copied: "In die Zwischenablage kopiert",
    copy: "Kopieren"
  },
  es: {
    copied: "Copiado al portapapeles",
    copy: "Copiar"
  },
  it: {
    copied: "Copiato negli appunti",
    copy: "Copiare"
  }
};

function getTranslation(key) {
  const locale = Helpers.documentLocale();
  return translations[locale][key] || translations['en'][key];
}
